import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiArrowLongRight } from "react-icons/hi2";
import {
  formatNewsDate,
  getVideoEmbedUrl,
  getYoutubeId,
  useNews,
} from "../../../http/useNews";
import {
  NewsFeatured,
  NewsImage,
  NewsLink,
  NewsVideo,
} from "../../News-page/components/NewsCard";

export const NewsSection = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { data: newsData } = useNews();

  if (!newsData?.articles?.length) return null;

  const [featured, ...rest] = newsData.articles;

  return (
    <section className="HomeNews">
      <div className="container">
        <div className="HomeNews-head" data-aos="fade-up">
          <div>
            <h6>{t("News")}</h6>
            <h2>{newsData.articleType?.name}</h2>
            <span className="HomeNews-bar" />
          </div>
          <Link to="/news" className="HomeNews-all">
            {t("All-News")}
            <HiArrowLongRight className="HomeNews-arrow" />
          </Link>
        </div>

        <div className="row g-4">
          <div className={rest.length ? "col-lg-7" : "col-12"} data-aos="fade-up">
            <NewsFeatured article={featured} solo={!rest.length} />
          </div>

          {rest.length > 0 && (
            <div className="col-lg-5" data-aos="fade-up">
              <div className="HomeNews-list">
                {rest.slice(0, 3).map((article) => {
                  const body = (
                    <>
                      <span className="NewsCard-date">{formatNewsDate(article.date, lang)}</span>
                      <h4>{article.name}</h4>
                    </>
                  );
                  // YouTube items play in the thumbnail; only the text links to the article
                  return getYoutubeId(article.path) ? (
                    <div className="HomeNews-item video" key={article.id}>
                      <NewsVideo article={article} className="HomeNews-thumb" />
                      <NewsLink article={article} className="HomeNews-item-body">
                        {body}
                      </NewsLink>
                    </div>
                  ) : (
                    <NewsLink article={article} className="HomeNews-item" key={article.id}>
                      <div className="HomeNews-thumb">
                        <NewsImage article={article} />
                        {getVideoEmbedUrl(article.path) && <span className="NewsCard-play sm" />}
                      </div>
                      <div className="HomeNews-item-body">{body}</div>
                    </NewsLink>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
